import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6df6ac9e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "log"
};
const _hoisted_2 = {
  class: "signIn"
};
const _hoisted_3 = {
  class: "lable"
};
const _hoisted_4 = {
  class: "lable"
};
const _hoisted_5 = {
  class: "lable"
};
const _hoisted_6 = {
  class: "lable"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lable"
}, [/*#__PURE__*/_createElementVNode("button", {
  class: "submit",
  type: "submit"
}, "注册")], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lable"
}, "提示:密码长度为6-16位字母和数字组合", -1));
import nav_header from '@/components/nav_header.vue';
import { onBeforeMount } from 'vue';
import msgs from '../components/prompt.vue';
import { register, codeImg } from '../util/http';

import { useRouter } from 'vue-router';
import { ref, reactive } from 'vue';
export default {
  __name: 'register',
  setup(__props) {
    const router = useRouter();
    let msg = ref('账号不能为空');
    let show = ref(false);
    let codeImage = ref('');
    let query = reactive({
      mobile: '',
      password: '',
      old_password: '',
      code: '',
      key: ''
    });
    let timeout;
    let msgss = () => {
      show.value = true;
      if (show.value) {
        timeout = setTimeout(() => {
          show.value = false;
        }, 1000);
      } else {
        clearTimeout(timeout);
      }
    };
    let onSubmit = e => {
      e.preventDefault();
      if (query.mobile == '' || query.password == '') {
        msgss();
        msg.value = '账号密码不能为空';
      } else if (query.old_password != query.password) {
        msgss();
        msg.value = '两次密码不一致';
      } else {
        show.value = false;
        registers(query);
      }
    };
    onBeforeMount(() => {
      codeImgs();
    });
    let registers = data => {
      register(data).then(res => {
        if (res.message == "注册成功") {
          localStorage.setItem('userInfo', JSON.stringify(res.data.user));
          localStorage.setItem('chat', JSON.stringify(res.data.chat));
          localStorage.setItem(res.data.token_type, res.data.token);
          router.push({
            path: `/`
          });
        } else {
          msgss();
          msg.value = res.message;
        }
      });
    };
    let repeatImg = () => {
      codeImgs();
    };
    let codeImgs = () => {
      codeImg().then(res => {
        codeImage.value = res.data.image;
        query.key = res.data.key;
      });
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: " "
      }, {
        more: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_router_link, {
          to: "/login"
        }, {
          default: _withCtx(() => [_createTextVNode(" 登陆 ")]),
          _: 1
        })])]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("form", {
        action: "",
        onSubmit: _cache[5] || (_cache[5] = (...args) => _unref(onSubmit) && _unref(onSubmit)(...args))
      }, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(query).mobile = $event),
        placeholder: "请输入账号"
      }, null, 512), [[_vModelText, _unref(query).mobile]])]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
        type: "password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(query).password = $event),
        placeholder: "请输入密码"
      }, null, 512), [[_vModelText, _unref(query).password]])]), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
        type: "password",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(query).old_password = $event),
        placeholder: "请再次输入密码"
      }, null, 512), [[_vModelText, _unref(query).old_password]])]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
        class: "code",
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(query).code = $event),
        placeholder: "请输入验证码"
      }, null, 512), [[_vModelText, _unref(query).code]]), _createElementVNode("div", {
        class: "img",
        onClick: _cache[4] || (_cache[4] = (...args) => _unref(repeatImg) && _unref(repeatImg)(...args))
      }, [_createElementVNode("img", {
        src: _unref(codeImage),
        alt: ""
      }, null, 8, _hoisted_7)])]), _hoisted_8, _hoisted_9], 32)]), _createVNode(msgs, {
        msg: _unref(msg),
        hidden: _unref(show)
      }, null, 8, ["msg", "hidden"])], 64);
    };
  }
};